import React from 'react';
import {
    Button,
    Menu,
    MenuItem,
    Tooltip
} from '@mui/material';
import { DownloadIcon } from '../../icons';

const TableDownloadBtn = () => {
    const [anchorEl, setAnchorEl] = React.useState(null);
    const open = Boolean(anchorEl);

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    return (
        <div>
            <Tooltip title="Download" arrow placement='top'>
                <Button
                    sx={{
                        background: '#fff',
                        borderRadius: '50px',
                        color: '#1A1F36',
                        fontSize: '16px',
                        textTransform: 'capitalize',
                        width: '40px',
                        height: '38px',
                        border: '1px solid #E5E8EB',
                        '&:hover': {
                            background: '#f5f5f5'
                        }
                    }}
                    onClick={handleClick}
                    aria-controls={open ? 'download-menu' : undefined}
                    aria-haspopup="true"
                    aria-expanded={open ? 'true' : undefined}
                >
                    <DownloadIcon />
                </Button>
            </Tooltip>

            <Menu
                id="download-menu"
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                MenuListProps={{
                    'aria-labelledby': 'download-button',
                }}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'right',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                }}
                PaperProps={{
                    style: {
                        borderRadius: '12px',
                        boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.1)',
                    },
                }}
            >
                <MenuItem onClick={handleClose} sx={{ fontSize: '14px', color: '#1A1F36', }}>To PDF</MenuItem>
                <MenuItem onClick={handleClose} sx={{ fontSize: '14px', color: '#1A1F36', }}>To CSV</MenuItem>
            </Menu>
        </div>
    );
}

export default TableDownloadBtn;